import OnlineAppComponent from "../lib/online_app_component";

export const OnlineAppProgressConfig = {
    baseHtmlClass: 'online_app__progress',
    selector: '.online_app__progress',
}

export class OnlineAppProgress extends OnlineAppComponent {

    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppProgressConfig);
        this.progress = 0.0;
        this.inited = true;
        this.render();
    }

    renderProgress() {
        this.progress = this.readStateMachineValue('bootProgress');
        this.element.innerHTML = (this.hasProgress() ? `<span style="display:none;">${this.progressPercentage()}%</span>` : '');
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, 'inited');
        this.conditionallySetHtmlClassState(this.isLoadingItems(), 'is_booting');
        this.renderProgress();
    }

    progressPercentage() {
        return (Math.floor(this.progress * 100)).toString();
    }

    hasProgress(){
        return this.progress > 0;
    }

    isLoadingItems() {
        return this.readStateMachineValue('loadingItems').length > 0;
    }

}

export function getProgress(element, onlineApp) {
    if (!element) return null;
    return new OnlineAppProgress(element, onlineApp);
}